import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Stack, TextField, Alert, Box, Button } from "@mui/material";
import { post } from "aws-amplify/api";
import LoaderButton from "../components/LoaderButton";
import FormPage from "../components/FormPage";

export default function UnregisterEmail() {
  const navigate = useNavigate();
  const location = useLocation();

  const initial = (() => {
    if (location.state) {
      try {
        localStorage.setItem("unregisterUserId", location.state.userId);
        localStorage.setItem("unregisterEmail", location.state.email);
      } catch (e) { /* ignore */ }
      return { email: location.state.email, userId: location.state.userId };
    }
    try {
      return {
        userId: localStorage.getItem("unregisterUserId") ?? "",
        email: localStorage.getItem("unregisterEmail") ?? ""
      };
    } catch (e) {
      return { userId: "", email: "" };
    }
  })();

  const [isDeleting, setIsDeleting] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsDeleting(true);
    setAlertMessage("");
    try {
      const op = post({
        apiName: "license",
        path: "/delete-user",
        options: { body: { userid: initial.userId } }
      });
      await op.response;
      navigate(-1);
    } catch (err) {
      setAlertMessage(err?.message ?? "Delete failed");
      setIsDeleting(false);
    }
  };

  return (
    <FormPage
      title="Unregister user"
      subtitle="This removes the user from your licensed seats. They will no longer be able to access DataStar."
    >
      {alertMessage ? (
        <Alert severity="error" onClose={() => setAlertMessage("")}>{alertMessage}</Alert>
      ) : null}
      <Box component="form" noValidate onSubmit={handleSubmit}>
        <Stack spacing={2.5}>
          <TextField
            label="Email"
            value={initial.email}
            type="email"
            InputProps={{ readOnly: true }}
          />
          <Stack direction="row" spacing={1.5}>
            <LoaderButton
              type="submit"
              color="error"
              isLoading={isDeleting}
              text="Unregister"
              loadingText="Removing…"
              fullWidth
            />
            <Button onClick={() => navigate(-1)} variant="outlined" disabled={isDeleting} fullWidth>
              Cancel
            </Button>
          </Stack>
        </Stack>
      </Box>
    </FormPage>
  );
}
